import type { Testimonial } from '../types/content';
export const stats = [['4', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['100%', 'Listo para usar']];
export const testimonials: Testimonial[] = [{
  name: 'Alicia B.',
  place: 'Buenos Aires',
  quote: 'Cuando empecé a cuidar a mi mamá, no sabía cómo organizar el día. Lo que más me sirvió fue tener las rutinas preparadas para saber qué tareas tener en cuenta.'
}, {
  name: 'Verónica P.',
  place: 'Córdoba',
  quote: 'Me preocupaba equivocarme con los cuidados de higiene. Tener procedimientos visuales y listas de materiales me ayuda a prepararme mejor antes de cada tarea.'
}, {
  name: 'Claudia F.',
  place: 'Rosario',
  quote: 'Antes buscaba información en distintos lugares. Ahora tengo los materiales organizados y puedo consultar lo que necesito sin perder tanto tiempo.'
}];
export const extendedTestimonials: Testimonial[] = [{
  name: 'Daniela L.',
  place: 'Mendoza',
  quote: 'Entre mis hermanos nos costaba repartir los cuidados de papá. Los mensajes preparados me parecen una forma muy práctica de pedir colaboración y coordinar los horarios.'
}, {
  name: 'Marcela V.',
  place: 'La Plata',
  quote: 'Una de mis mayores preocupaciones era no reconocer cuándo debía pedir ayuda. El manual de seguridad me sirve como referencia para tener más claros los motivos de consulta.'
}, {
  name: 'Patricia S.',
  place: 'Neuquén',
  quote: 'En las consultas médicas siempre me olvidaba de preguntar algo. Los guiones me ayudan a llevar las dudas anotadas y aprovechar mejor cada conversación.'
}, {
  name: 'Elena R.',
  place: 'Mar del Plata',
  quote: 'Cuidar a mi marido ocupa gran parte del día. Tener un plan de autocuidado con pausas breves me recuerda que también necesito organizar pequeños momentos de descanso.'
}];
